import styled from "styled-components";
import wavyOctagon from "../../../assets/images/general/wavy-octagon.png";
import { fonts } from "../../../styles/variables";
import discoverIcon from "../../../assets/images/icons/discover-and-learn.svg";

export const ChallengeDescriptionTableImageWrapper = styled.div`
  height: 50px;
  width: 50px;
  min-width: 50px;
  margin-right: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ChallengeBadgeImageBackground = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  width: 50px;
  background: url("${wavyOctagon}") no-repeat 100% 100% / cover;
`;

export const ChallengeBadgeImage = styled.img`
  height: 35px;
  width: 35px;
`;

export const ChallengeDescriptionTableText = styled.p`
  font-size: 14px;
  line-height: 23px;
  font-family: ${fonts.fontBauRegular};
  margin-bottom: 0px !important;
`;

export const ChallengeDescriptionTitle = styled.h3`
  font-size: 14px;
  font-family: ${fonts.fontInterstateUltraBlack};
  text-transform: uppercase;
  margin-bottom: 20px;
`;

export const ChallengeDescriptionTableContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const DiscoverImage = styled.img.attrs(() => ({
  src: discoverIcon,
}))`
  height: 20px;
  width: 25px;
`;
